export default __webpack_public_path__ + "static/media/reg_4.28526171.webp";